<template>
  <div>
    <el-dialog
      title="分享设置"
      :visible.sync="visible"
      width="800px"
      :close-on-click-modal="false"
    >
      <div class="boxLayout">
        <el-form :model="formData" label-width="95px" ref="form" :rules="rules">
          <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
              <span>通用分享设置</span>
              <p class="font-12 color-999">修改小程序页面分享设置</p>
            </div>
            <el-form-item label="分享类型" prop="type">
              <el-input
                v-model="formData.type"
                placeholder="按照输入的值来获取分享设置"
              ></el-input>
            </el-form-item>
            <el-form-item label="分享名称" prop="name">
              <el-input v-model="formData.name"></el-input>
            </el-form-item>
            <el-form-item label="分享描述" prop="desc">
              <el-input v-model="formData.desc"></el-input>
            </el-form-item>
            <el-form-item label="分享封面">
              <el-button class="avatar-uploader" @click="chooseBanner(1)">
                <img
                  v-if="formData.img_url"
                  :src="formData.img_url"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <i
                  v-if="formData.img_url"
                  class="el-icon-delete"
                  @click.stop="formData.img_url = ''"
                ></i>
              </el-button>
              <p class="font-12 color-999">
                *
                请按xxx*xxx尺寸上传png/jpg格式且小于2m的图片/若不上传则默认分享当前页面截图
              </p>
            </el-form-item>
          </el-card>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dismiss">取 消</el-button>
        <el-button type="primary" @click="submit('form')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="选择图片"
      :visible.sync="dialogVisible"
      width="80%"
      :close-on-click-modal="false"
    >
      <MaterialLibrary :type="imgType" @selectImg="selectImg" />
      <span slot="footer" class="dialog-footer text-center">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import MaterialLibrary from "../../../components/materialLibraryDialog/index.vue";
export default {
  components: {
    MaterialLibrary,
  },
  data() {
    return {
      visible: false,
      dialogVisible: false,
      imgType: "",
      type: "",
      formData: {
        name: "",
        desc: "",
        img_url: "",
      },
      rules: {
        type: { required: true, message: "请输入", trigger: "blur" },
        name: { required: true, message: "请输入", trigger: "blur" },
        desc: { required: true, message: "请输入", trigger: "blur" },
      },
    };
  },
  methods: {
    // 选择banner
    chooseBanner(n) {
      this.type = n;
      this.imgType = "chooseThumbnail_image";
      this.dialogVisible = true;
    },
    // 选择封面
    selectImg(item) {
      this.formData.img_url = item.url;
      this.dialogVisible = false;
    },
    submit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          const params = {
            ...this.formData,
          };
          const query = params.id ? `/${params.id}` : "";
          const url = `https://time.api.boyalife.cn/v1/cms/ShareSettingV2${query}`;
          const options = {
            method: params.id ? "put" : "post", //请求方法
            headers: {
              "Content-Type": "application/json",
              "X-Access-Token": this.storage.get("__token"),
              Authorization: `Bearer ${this.storage.get("__token")}`,
            },
            data: params,
            url,
          };
          this.axios(options)
            .then((res) => {
              this.$message.success("保存成功！");
              this.dismiss();
              this.$emit("ok");
            })
            .catch((err) => {
              this.$message.error(err.response.data.error.message);
            });
        } else {
          return false;
        }
      });
    },
    dismiss() {
      this.visible = false;
    },
    open(data = {}) {
      this.formData = {
        ...data,
      };
      this.visible = true;
    },
  },
};
</script>
<style scoped>
.avatar-uploader >>> .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar-uploader {
  position: relative;
}
.avatar-uploader .el-icon-delete {
  font-size: 20px;
  position: absolute;
  right: -40px;
  bottom: 0px;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
